module.exports = __webpack_public_path__ + "static/media/washington-dc-60.2b7ece8e.jpg";